<template>
  <div class="page-real-time" :style="{ height: pageHeight + 'px' }">
    <div class="real-time">
      <div class="option-box">
        <div class="option">
          <el-select v-model="tower" filterable placeholder="选择楼" @change="towerChange">
            <el-option
              v-for="item in towers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select v-model="floor" placeholder="选择层" @change="floorChange">
            <el-option
              v-for="item in floors"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select v-model="room" placeholder="选择房" @change="roomChange">
            <el-option
              v-for="item in rooms"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select v-model="bed" placeholder="选择位置" @change="bedChange">
            <el-option
              v-for="item in beds"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input style="max-width: 120px; margin-right: 20px;" placeholder="雷达SN" v-model="searchSn" @input="searchChange"></el-input>
        </div>
        <div class="option">
          <!-- <hm-button class="option-btn" @click="selData">筛选</hm-button> -->
          <hm-button class="option-btn" @click="refesh">刷新</hm-button>
        </div>
      </div>
      <div class="monitor-info-title">
        <div>房间</div>
        <div>位置</div>
        <div>设备SN</div>
        <div>设备状态</div>
        <div>有无人</div>
        <!-- <div>在床时间</div>
        <div>离床时间</div>
        <div>体动次数</div> -->
        <div>当前呼吸值(次/分钟)</div>
        <div>当前心跳值(次/分钟)</div>
      </div>
      <el-scrollbar style="height: 100%">
        <div class="list-box">
          <div
            class="monitor-info"
            :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in monitorList"
            :key="index"
          >
            <!-- <div @click="showMonitorInfo(item, index)">{{ item.location }}</div> -->
            <div>{{ item.roomName }}</div>
            <div>{{ item.location }}</div>
            <div>{{ item.sn }}</div>
            <div>
              {{
                item.status == 1
                  ? "正常"
                  : item.status == 0
                  ? "非监控时间段"
                  : "异常"
              }}
            </div>
            <div>
              {{
                item.radarType == "1002"
                  ? item.trackNum == 1
                    ? "有"
                    : "无"
                  : item.hasPeople == 1
                  ? "有"
                  : "无"
              }}
            </div>
            <!-- <div>
              {{
                item.radarType == "1002"
                  ? "--"
                  : item.bedTime
                  ? item.bedTime
                  : "--"
              }}
            </div>
            <div>
              {{
                item.radarType == "1002"
                  ? "--"
                  : item.leaveTime
                  ? item.leaveTime
                  : "--"
              }}
            </div>
            <div>
              {{
                item.radarType == "1002"
                  ? "--"
                  : item.turnTimes
                  ? item.turnTimes
                  : item.turnTimes == 0
                  ? 0
                  : "--"
              }}
            </div> -->
            <div>
              {{
                item.radarType == "1002"
                  ? "--"
                  : item.breathFreqAvg || item.breathFreqAvg == 0
                  ? item.breathFreqAvg.toFixed(2)
                  : "--"
              }}
            </div>
            <div>
              {{
                item.radarType == "1002"
                  ? "--"
                  : item.heartFreqAvg || item.heartFreqAvg == 0
                  ? item.heartFreqAvg.toFixed(2)
                  : "--"
              }}
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <div class="mask-box" v-show="isMask" ref="mask">
      <div class="info-box">
        <div class="info-title-box">
          <div class="blue-point"></div>
          <div class="info-title">实时数据</div>
          <el-button class="back-btn" @click="back">返回</el-button>
        </div>
        <div class="info-content">
          <div class="left-info-content">
            <div class="left-one">
              <div>有人</div>
              <div
                class="monitor-people"
                :class="monitorData.people == 1 ? 'monitor-exist-people' : ''"
              ></div>
              <div>无人</div>
              <div
                class="monitor-people"
                :class="monitorData.people == 0 ? 'monitor-exist-people' : ''"
              ></div>
            </div>
            <div class="left-two">
              <div>体动</div>
              <div class="monitor-bed-time">{{ monitorData.turnTimes }}</div>
              <div>起身</div>
              <div class="monitor-bed-time">{{ monitorData.getUp }}</div>
            </div>
            <div class="left-three">
              <div>离床时间</div>
              <div class="monitor-bed-time">
                {{ monitorData.leaveTime }}
              </div>
              <div>在床时间</div>
              <div class="monitor-bed-time">
                {{ monitorData.bedTime }}
              </div>
            </div>
          </div>
          <div class="right-info-content">
            <div class="right-one">
              <div class="breather-box">
                <img :src="breatherImg" class="breather-img" />
                <div class="breather-text">
                  {{ parseInt(monitorData.freqBreath * 60) }}
                </div>
                <div id="breather"></div>
              </div>
              <div class="heart-box">
                <img :src="heartImg" class="breather-img" />
                <div class="breather-text">
                  {{ parseInt(monitorData.freqHeart * 60) }}
                </div>
                <div id="heart"></div>
              </div>
            </div>
            <div class="right-two">
              <div class="breather-box">
                <img :src="breatherImg" class="breather-img" />
                <div id="breatherPhase"></div>
              </div>
              <div class="heart-box">
                <img :src="heartImg" class="breather-img" />
                <div id="heartPhase"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 单个的话传 雷达的sn号，  多个话传0就行
// public class DeviceReportBo {
//     //雷达IP
//     @JsonProperty("ip")
//     private String ip;
//     //雷达端口
//     @JsonProperty("port")
//     private int port;
//     // 呼吸频率
//     @JsonProperty("freq_breath")
//     private float freqBreath;
//     // 心跳频率
//     @JsonProperty("freq_heart")
//     private float freqHeart;
//     // 呼吸相位
//     @JsonProperty("phase_breath")
//     private float phaseBreath;
//     // 心跳相位
//     @JsonProperty("phase_heart")
//     private float phaseHeart;
//     // 有无人
//     private int people;
//     // 有无翻身
//     private int turn;
//     // 起身标志
//     @JsonProperty("flag_get_up")
//     private int flagGetUp;
//     //时间
//     @JsonProperty("date_time")
//     private Timestamp dateTime;
// }
import {
  getBuilding,
  getFloor,
  getRoom,
  getBed,
  getDevice,
} from "../api/device";

import * as echarts from "echarts/core";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
} from "echarts/components";
import { LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
]);
let wsHeartTimer;
export default {
  name: "RealTime",
  data() {
    return {
      pageHeight: 0,
      // wsUrl: "wss://27.128.229.34:8082/sstk-plat/ws/data",
      wsUrl: "wss://applet.whst.com/wss/sstk-plat/ws/data",
      // wsUrl: "ws://120.211.103.37:8082/sstk-plat/ws/data",
      // wsUrl: `ws://${location.host}/websocket/sstk-plat/ws/data`,
      isManage: false,
      userRooms: [],
      userFloors: [],
      userBuildings: [],
      tower: "",
      floor: "",
      room: "",
      bed: "",
      towers: [],
      floors: [],
      rooms: [],
      beds: [],
      allDevices: [],
      devices: [],

      monitorList: [],

      isMask: false,
      heartImg: require("../assets/images/main/heart.svg"),
      breatherImg: require("../assets/images/main/breather.svg"),
      timeData: [],
      heartChart: null,
      breatherChart: null,
      heartPhaseChart: null,
      breatherPhaseChart: null,
      heartData: [],
      breatherData: [],
      heartPhaseData: [],
      breatherPhaseData: [],

      heartTimer: null,
      breatherTimer: null,
      heartPhaseTimer: null,
      breatherPhaseTimer: null,
      monitorData: {},
      searchSn: ""
    };
  },
  created() {
    if (this.$store.getters.user.roleId != 1) {
      this.userRooms = this.$store.getters.user.roomList;
      this.userFloors = this.$store.getters.user.floorList;
      this.userBuildings = this.$store.getters.user.buildingList;
    } else {
      this.isManage = true;
    }
  },
  mounted() {
    this.initPageHeight();

    if (this.$store.getters.user.id) {
      this.webSocketInit();
    }

    window.addEventListener("resize", this.initPageHeight, false);

    this.getTowers();
    this.getFloors();
    this.getRooms();
    this.getBeds();
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    searchChange(){
      this.getDevices()
    },

    refesh() {
      this.tower = "";
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.searchSn = ""
      this.getTowers();
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 获取楼列表
    getTowers() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (!this.isManage) {
              if (this.userBuildings.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              let obj = {
                value: item.id,
                label: item.name,
              };
              list.push(obj);
            }
          });
        }

        this.towers = list;
      });
    },

    // 选择楼
    towerChange(e) {
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 获取层列表
    getFloors() {
      getFloor({
        page: 1,
        size: 9999,
        buildingId: this.tower,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (!this.isManage) {
              if (this.userFloors.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              let obj = {
                value: item.id,
                label: item.name,
              };
              list.push(obj);
            }
          });
        }

        this.floors = list;
      });
    },

    // 选择层
    floorChange(e) {
      this.room = "";
      this.bed = "";
      this.getRooms();
      this.getBeds();
    },

    // 获取房列表
    getRooms() {
      getRoom({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            // 判断用户权限
            if (!this.isManage) {
              if (this.userRooms.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              item.value = item.id;
              item.label = item.name;
              list.push(item);
            }
          });
        }

        this.rooms = list;
      });
    },

    // 选择房
    roomChange(e) {
      this.bed = "";
      this.getBeds();
    },

    // 获取位置列表
    getBeds() {
      getBed({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
        roomId: this.room,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            // 判断用户权限
            if (!this.isManage) {
              if (this.userRooms.indexOf(Number(item.roomId)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              item.value = item.id;
              item.label = item.name;
              list.push(item);
            }
          });
        }

        this.beds = list;

        this.getDevices();
      });
    },

    // 选择位置
    bedChange(e) {
      if (this.devices.length > 0) {
        let list = [];
        this.devices.forEach((item) => {
          if (item.bedId == this.bed) {
            list.push(item);
          }
        });

        this.devices = list;
      }
    },

    // 获取设备列表
    getDevices() {
      let obj = {
        page: 1,
        size: 9999,
        radarType: '1001', //  体征雷达
        id: this.$store.getters.user.id,
        sn: this.searchSn
      };
      if (this.tower) {
        obj.buildingId = this.tower;
      } else if (!this.isManage) {
        // obj.buildingId = this.userBuildings.join(',');
      }

      if (this.floor) {
        obj.floorId = this.floor;
      } else if (!this.isManage) {
        // obj.floorId = this.userFloors.join(',');
      }

      if (this.room) {
        obj.roomId = this.room;
      } else if (!this.isManage) {
        // obj.roomId = this.userRooms.join(',');
      }
      getDevice(obj).then((res) => {
        if (res.data.records.length > 0) {
          this.allDevices = res.data.records;
          let list = [];
          this.allDevices.forEach((item) => {
            this.beds.forEach((itm) => {
              if (item.bedId == itm.id) {
                item.location = itm.name;
                item.roomName = itm.roomName;
                item.floorName = itm.floorName;
                item.towerName = itm.buildingName;
                
              }
            });
            list.push(item);
          });

          this.devices = list;

          console.log('============',this.devices)
        }
      });
    },

    // 筛选数据
    selData() {},

    webSocketInit() {
      let that = this;
      // that.wsUrl = `${that.wsUrl}/${that.$store.getters.user.uuid}`

      // 判断websocket环境
      if ("WebSocket" in window) {
        that.webSocket = new WebSocket(that.wsUrl);
      } else if ("MozWebSocket" in window) {
        that.webSocket = new MozWebSocket(that.wsUrl);
      } else {
        that.webSocket = new SockJS(that.wsUrl);
      }

      // websocket连接
      that.webSocket.onopen = () => {
        console.log("websocket连接成功");
        that.webSocket.send(
          JSON.stringify({
            type: 0,
            userId: that.$store.getters.user.uuid,
          })
        );

        wsHeartTimer = setInterval(() => {
          console.log("websocket心跳");
          that.webSocket.send(
            JSON.stringify({
              msg: "heart",
              userId: that.$store.getters.user.uuid,
            })
          );
        }, 5000);
      };

      // websocket接收消息
      that.webSocket.onmessage = (msg) => {
        let data = [];
        try {
          data = JSON.parse(msg.data);
        } catch (error) {}
        // console.log(data);

        if (data.length > 0 && that.devices.length > 0) {
          let list = [];
          data.forEach((item) => {
            that.devices.forEach((itm) => {
              if (item.sn == itm.sn) {
                // item.location = itm.location;
                let _inBedTime = parseInt(item.peopleTimeHave * 0.05 || 0);
                let _outBedTime = parseInt(item.peopleTimeLeave * 0.05 || 0);
                itm.bedTime = that.formatTime(_inBedTime);
                itm.leaveTime = that.formatTime(_outBedTime);
                itm.radarType = itm.radarType;
                itm.status = item.radarStatus;
                itm.turnTimes = item.turnTimes;
                itm.freqBreath = item.freqBreath;
                itm.freqHeart = item.freqHeart;
                itm.people = item.people;
                itm.turnTimes = item.turnTimes;
                itm.getUp = item.getUp;
                itm.hasPeople = item.hasPeople;
                itm.breathFreqAvg = item.breathFreqAvg;
                itm.heartFreqAvg = item.heartFreqAvg;
                list.push(itm);

                // 提示跌倒
                if (item.flagFall == 1 && item.radarType == "1002") {
                  this.$notify({
                    title: "警告",
                    message: `${itm.towerName}-${itm.floorName}-${itm.roomName}-${itm.location}有人跌倒`,
                    type: "warning",
                    duration: 0,
                  });
                }
              }
            });
          });
          that.monitorList = JSON.parse(JSON.stringify(that.devices));

          if (that.isMask) {
            that.monitorData = list[0];
          }
        } else {
          that.monitorList = JSON.parse(JSON.stringify(that.devices));
        }

        if (data.length == 1 && that.isMask) {
          data.forEach((item) => {
            that.shiftArray(that.timeData);
            that.shiftArray(that.heartData);
            that.shiftArray(that.breatherData);
            that.shiftArray(that.heartPhaseData);
            that.shiftArray(that.breatherPhaseData);

            that.timeData.push(item.dateTime);
            that.heartData.push(parseInt(item.freqHeart * 60));
            that.breatherData.push(parseInt(item.freqBreath * 60));
            that.heartPhaseData.push(item.phaseHeart);
            that.breatherPhaseData.push(item.phaseBreath);
          });
        }
      };

      // websocket错误
      that.webSocket.onerror = (ev) => {
        console.log("websocket错误");
        clearInterval(wsHeartTimer);
        // this.$message({
        //   type: "error",
        //   message: "网络连接错误",
        // });

        // that.webSocketInit()
      };

      // websocket关闭
      that.webSocket.onclose = (e) => {
        console.log("websocket关闭", e);
        clearInterval(wsHeartTimer);

        if (e.code == 1006) {
          that.webSocketInit();
        }
      };
    },

    // 时间处理
    formatTime(time) {
      let hour = parseInt(time / 3600);
      let min = parseInt((time % 3600) / 60);
      let sec = (time % 3600) % 60;

      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }

      return `${hour}:${min}:${sec}`;
    },

    // 数组处理
    shiftArray(arr) {
      if (arr.length > 255) {
        arr.shift();
      }
    },

    showMonitorInfo(data) {
      if (data.radarType == "1001") {
        this.isMask = true;
        this.webSocket.send(
          JSON.stringify({
            type: data.sn,
            userId: this.$store.getters.user.uuid,
          })
        );
        document.getElementsByTagName("body")[0].appendChild(this.$refs.mask);
        document.getElementById("app").style.filter = "blur(2px)";

        // this.$nextTick(() => {
        //   this.initBreather();
        //   this.initHeart();
        //   this.initBreatherPhase();
        //   this.initHeartPhase();
        // });
        setTimeout(() => {
          this.initBreather();
          this.initHeart();
          this.initBreatherPhase();
          this.initHeartPhase();
        }, 1000);
      } else {
        this.$message("请选择生命监测雷达");
      }
    },

    back() {
      this.webSocket.send(
        JSON.stringify({ type: 0, userId: this.$store.getters.user.uuid })
      );
      clearInterval(this.heartTimer);
      clearInterval(this.breatherTimer);
      clearInterval(this.breatherPhaseTimer);
      clearInterval(this.heartPhaseTimer);
      this.heartChart.dispose();
      this.breatherChart.dispose();
      this.heartPhaseChart.dispose();
      this.breatherPhaseChart.dispose();
      this.isMask = false;
      document.getElementsByTagName("body")[0].removeChild(this.$refs.mask);
      document.getElementById("app").style.filter = "blur(0px)";
    },

    initHeart() {
      let that = this;
      var chartDom = document.getElementById("heart");
      that.heartChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: that.timeData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        grid: {
          top: 20,
          bottom: 20,
        },
        yAxis: {
          type: "value",
          data: that.heartData,
          splitLine: {
            show: false,
          },
          splitNumber: 1,
        },
        series: [
          {
            data: that.heartData,
            type: "line",
            smooth: true,
            symbol: "none",
          },
        ],
      };

      that.heartChart.setOption(option);
      that.heartTimer = setInterval(() => {
        that.heartChart.setOption(option);
        // that.heartChart.setOption({
        //   series: [
        //     {
        //       data: that.heartData,
        //     },
        //   ],
        // });
      }, 50);
    },

    initBreather() {
      var chartDom = document.getElementById("breather");
      this.breatherChart = echarts.init(chartDom);
      var option;

      option = {
        grid: {
          top: 20,
          bottom: 20,
        },
        xAxis: {
          type: "category",
          data: this.timeData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          data: this.breatherData,
          splitLine: {
            show: false,
          },
          splitNumber: 1,
        },
        series: [
          {
            data: this.breatherData,
            type: "line",
            smooth: true,
            symbol: "none",
          },
        ],
      };

      this.breatherChart.setOption(option);
      this.breatherTimer = setInterval(() => {
        this.breatherChart.setOption(option);
        // this.breatherChart.setOption({
        //   series: [
        //     {
        //       data: this.breatherData,
        //     },
        //   ],
        // });
      }, 50);
    },

    initBreatherPhase() {
      var chartDom = document.getElementById("breatherPhase");
      this.breatherPhaseChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: this.timeData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          data: this.breatherPhaseData,
          splitLine: {
            show: false,
          },
          splitNumber: 1,
        },
        series: [
          {
            data: this.breatherPhaseData,
            type: "line",
            smooth: true,
            symbol: "none",
          },
        ],
      };

      this.breatherPhaseChart.setOption(option);
      this.breatherPhaseTimer = setInterval(() => {
        this.breatherPhaseChart.setOption(option);
        // this.breatherPhaseChart.setOption({
        //   series: [
        //     {
        //       data: this.breatherPhaseData,
        //     },
        //   ],
        // });
      }, 50);
    },

    initHeartPhase() {
      var chartDom = document.getElementById("heartPhase");
      this.heartPhaseChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: this.timeData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          data: this.heartPhaseData,
          splitLine: {
            show: false,
          },
          splitNumber: 1,
        },
        series: [
          {
            data: this.heartPhaseData,
            type: "line",
            smooth: true,
            symbol: "none",
          },
        ],
      };

      this.heartPhaseChart.setOption(option);
      this.heartPhaseTimer = setInterval(() => {
        this.heartPhaseChart.setOption(option);
        // this.heartPhaseChart.setOption({
        //   series: [
        //     {
        //       data: this.heartPhaseData,
        //     },
        //   ],
        // });
      }, 50);
    },
  },
  beforeDestroy() {
    if (this.isMask) {
      this.back();
    }

    if (this.webSocket) {
      this.webSocket.close();
    }

    clearInterval(wsHeartTimer);

    window.removeEventListener("resize", this.initPageHeight, false);
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-real-time {
  width: 100%;
  // padding: 63px 63px 0 63px;
  padding: 20px;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .real-time {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 40px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .option-box {
      display: flex;
      // justify-content: space-between;
      justify-content: center;

      .option {
        display: flex;
      }

      .option-btn {
        width: 182px;
        height: 40px;
      }
    }

    .monitor-info-title {
      height: 40px;
      line-height: 40px;
      display: flex;
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 40px;

      div {
        flex: 1;
        text-align: center;
      }
    }

    .list-box {
      flex: 1;

      .monitor-info {
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 15px;

        div {
          flex: 1;
          text-align: center;
        }

        div:first-child {
          cursor: pointer;
          color: #1d63fd;
        }
      }
    }
  }

  .page-num-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;

    .page-num-list {
      height: 60px;
      display: flex;
      align-items: center;

      .page-num {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #26415f;
      }

      .page-num-active {
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #c9d5ef;
        border-radius: 8px;
      }
    }
  }
}
</style>
<style>
.el-select {
  width: 180px;
  margin-right: 36px;
}
.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
.el-input__inner {
  border-color: 1px solid#c9d5e7;
  border-radius: 8px;
}
.mask-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(33, 64, 132, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-box {
  width: 1401px;
  height: 881px;
  background: #efefef;
  border-radius: 12px;
  overflow: hidden;
}
.info-title-box {
  width: 100%;
  height: 111px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.blue-point {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1d63fd;
  margin-right: 12px;
  margin-top: 6px;
}
.info-title {
  font-size: 30px;
  margin-right: 500px;
  color: #26415f;
}
.info-box .back-btn {
  width: 100px;
  height: 40px;
  background: #1d63fd;
  color: #fff;
  border: none;
  margin-right: 40px;
}
.info-content {
  width: 100%;
  height: 770px;
  padding: 51px 88px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.left-info-content {
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.left-one {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.monitor-people {
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  border: 1px solid #c9d5ef;
  background: #fff;
}
.monitor-exist-people {
  background: #1d63fd;
}
.left-two {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.left-three {
  width: 200px;
  height: 237px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
}

.monitor-bed-time {
  color: #1d63fd;
  font-size: 25px;
}

.right-info-content {
  flex: 1;
  height: 100%;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right-one {
  width: 1010px;
  height: 326px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}
.breather-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.breather-text {
  font-size: 25px;
  color: #1d63fd;
}
#breather {
  flex: 1;
  height: 100%;
}
.heart-box {
  flex: 1;
  display: flex;
  align-items: center;
}
#heart {
  flex: 1;
  height: 100%;
}
.breather-img {
  margin: 0 20px;
}
.right-two {
  width: 1010px;
  height: 326px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}
#heartPhase {
  flex: 1;
  height: 250px;
  position: relative;
  top: 50%;
  margin-top: -150px;
}
#breatherPhase {
  flex: 1;
  height: 250px;
  position: relative;
  top: 50%;
  margin-top: -150px;
}
</style>


// WEBPACK FOOTER //
// src/views/realTime.vue